import { getFromServerToken } from "./fetch";
import { useState, useEffect, useContext } from "react";
import EventContext from "../store/event-context";


const useParticipantOverviewService = () => {
  const [isLoadingParticipants, setIsLoading] = useState(false);
  const [participantsData, setData] = useState();
  const [participantsServerError, setServerError] = useState(null);
  const [nextToken, setNextToken] = useState();
  const eventctx = useContext(EventContext);

  const nextParticipants = () => {
    console.log("UPDATING");
    if (nextToken) {
      return queryparticipants();
    }
  };

  const displayCapnr = (capNr) => {
    let result = capNr;
    // console.log("displayCapnr - Capnr: ", capNr, " - Event",eventctx.event)
    if (eventctx.event && eventctx.event.colors.length === 1) {
        const hlpArray = capNr.split(":");
        result = hlpArray[1];
    }
    return result;
  }

  useEffect(() => {
    localStorage.setItem("participantsData", JSON.stringify(participantsData));
  }, [participantsData]);

  useEffect(() => {
    localStorage.setItem("participantsToken", nextToken);
  }, [nextToken]);

  const queryparticipants = async () => {
    console.log("Querying data");
    setIsLoading(true);
    let query = "";
    let append = false;

    if (nextToken) {
      console.log("Querying next part");
      query = "?nextToken=" + nextToken;
      append = true;
    }
    try {
      const { data, status } = await getFromServerToken(`/events/${eventctx.eventId}/overview` + query);
      if (status > 204) {
        console.log("USER ERROR: ");
        setServerError(data.detail);
        setData([]);
      } else if (status === 204) {
        // Change backend to respond with a 204 if no entries found but no error
        setData({});
        setServerError("No Match found");
      } else {
        setNextToken(data.token); // can be an empty String. Check that this is handled correctly
        // TODO if current state matches state, append data
        if ("participants" in data && data.participants.length) {
          console.log("Now refreshing - Number of participants returned: ", data.participants.length);

          // We need the table data for the striped row background
          // If we already have some data in participantsData, we need to append and start the table index from that point...
          let i = (append && participantsData)? participantsData.length : 0;
          let tmpData = data.participants.map((item, index) => {
              item.fullName = item.firstName + " " + item.lastName;
              item.displayCapnr = displayCapnr(item.capnr);
              item.participantId = item.id;
              item.id = i + index;          // New row id
              return item;
          }); 

          if (append && participantsData) {
            setData([...participantsData, ...tmpData]);
          } else {
            setData(tmpData);
          }
          setServerError("");
        } else {
          setData([]);
          setServerError("Geen deelnemers gevonden");
        }
      }
    } catch (error) {
      console.log("FETCH ERROR queryparticipants");
      console.log(error);
      setData([]);
      setServerError("Network error?. Het kan helpen om de pagina te verversen");
    }
    setIsLoading(false);
  };

  return {
    participantsData,
    isLoadingParticipants,
    participantsServerError,
    queryparticipants,
    nextParticipants,
    nextToken,
  };
};

export default useParticipantOverviewService;
